import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import { actions } from '../constants/survey';
import { ISurveysSetAction, ISetAddSurvey, ISetDeleteSurvey, ILoginSurveySetAction } from '../../models/action/survey';

const _logger = Log.create('Survey Reducer');

const setSurveyData = (newState: any, surveyPageAction: any  ) => {
    if (surveyPageAction) {
        newState.surveyData = {
            activityId: surveyPageAction.activityId,
            abbreviation: surveyPageAction.abbreviation,
            name: surveyPageAction.name,
            description: surveyPageAction.description,
            isCommon: surveyPageAction.isCommon ? 1 : 0,
            dateCriteria: surveyPageAction.dateCriteria,
            datePrerequisiteActivityHours: surveyPageAction.datePrerequisiteActivityHours ?? '',
            datePrerequisiteActivityId: surveyPageAction.datePrerequisiteActivityId ? [surveyPageAction.datePrerequisiteActivityId] : '',
            prerequisiteActivityId: surveyPageAction.prerequisiteActivityId ?? '',
            completionType: surveyPageAction.completionType ?? 3,
            alwaysOnTop: surveyPageAction.alwaysOnTop,
            dateRange: '',
            fileInputKey: '',
            photoUploadKey: '',
            activityConditionalBeginDate: surveyPageAction.beginDate,
            activityConditionalEndDate: surveyPageAction.endDate,
            termWeekIds: surveyPageAction.termWeekIds,
            selectedActivityOwnersTagIds: surveyPageAction.selectedActivityOwnersTagIds,
            selectedActivityUnitsTagIds: surveyPageAction.selectedActivityUnitsTagIds,
            selectedClass: surveyPageAction.selectedClass,
            allUnits: surveyPageAction.allUnits,
            courseId: surveyPageAction.courseId,
            file: surveyPageAction.file && surveyPageAction.file.length > 0 ? surveyPageAction.file : null,
            deletedFilesId: [],
            cardImgName: surveyPageAction.cardImgName,
            taskDeadline: surveyPageAction.taskDeadLine,
            taskDeadlinetime: '',
            activityType: '10',
            surveyInfo: surveyPageAction.surveyInfo,
            learningOutcomeId: surveyPageAction.learningOutcomeId,
        };
    }
}

const surveyReducer = (state = GlobalState().survey, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = { ...state };
    if (action.type === actions.ADD_SURVEY_SET_ACTIVITY) {
        const surveyPageActionPayload = (action as unknown) as ISetAddSurvey;
        const surveyPageAction = surveyPageActionPayload?.surveyData ? surveyPageActionPayload.surveyData[0] : null;
        setSurveyData(newState, surveyPageAction);
        
    } else if (action.type === actions.DELETE_SURVEY_SET_ACTIVITY) {
        const surveyPageAction = (action as ISetDeleteSurvey);
        newState.deleteSurveyStatus = surveyPageAction.deleteSurveyStatus;
    } else if (action.type === actions.SET_SURVEY_DATA_DEFAULT) {
        newState.surveyData = {
            activityId: '',
            name: '',
            description: '',
            isCommon: 0,
            dateCriteria: 0,
            datePrerequisiteActivityHours: '',
            datePrerequisiteActivityId: '',
            prerequisiteActivityId: '',
            completionType: 3,
            alwaysOnTop: 0,
            dateRange: '',
            fileInputKey: '',
            photoUploadKey: '',
            activityConditionalBeginDate: '',
            activityConditionalEndDate: '',
            termWeekIds: [],
            selectedActivityOwnersTagIds: [],
            selectedActivityUnitsTagIds: [],
            selectedClass: [],
            allUnits: false,
            file: null,
            deletedFilesId: [],
            cardImgName: '',
            taskDeadline: '',
            activityType: '10',
            surveyInfo: undefined,
            learningOutcomeId: null,
        };
    }
    else if (action.type === actions.GET_SURVEY_LIST) {
        const pageData = (action as ILoginSurveySetAction);
        newState.surveyData = pageData.loginSurveyData;
    } else if (action.type === actions.SET_SURVEY_LIST) {
        const surveyPageAction = action as ISurveysSetAction;
        newState.homePageSurveys = surveyPageAction.surveys;
    }
    else if (action.type === actions.SET_SELECTED_LOGIN_SURVEY) {
        const surveyPageAction = action as any;

        if (surveyPageAction.selectedSurvey != null && newState.selectedSurvey == null) {
            newState.selectedSurvey = surveyPageAction.selectedSurvey;
        }
    } else if (action.type === actions.SET_SELECTED_GENERAL_SURVEY) {
        const surveyPageAction = action as any;
        if (surveyPageAction.selectedSurvey) {
            newState.selectedGeneralSurvey = surveyPageAction.selectedSurvey;
        }
    }
    return Object.assign({}, state, newState);
};

export default surveyReducer;